import {Action, Selector, State, StateContext, StateToken, Store} from '@ngxs/store';
import {GetReferralAction, GetReferralTokenAction} from '../actions/referral.action';
import {catchError, tap} from 'rxjs/operators';
import {throwError} from 'rxjs';
import {Injectable} from '@angular/core';
import {UserProfileApiService} from '../api/user-profile-api.service';
import {ReferralModel} from '../models/referral.model';
import {PageableApiResult} from '../models/pagable-api-result.model';
import {ReferralListFilterModel} from '../models/referral-list-filter.model';
import {Constants} from '../util/constants';

export interface ReferralStateModel{
  token: string,
  referralList: ReferralModel[],
  referral: ReferralModel,
  referralPage: PageableApiResult<ReferralModel>,
  referralListFilter: ReferralListFilterModel,
}
const initialState: ReferralStateModel = {
  referral: null,
  referralList: null,
  token : null,
  referralPage: null,
  referralListFilter: null
}

@State<ReferralStateModel>({
  name: new StateToken<ReferralStateModel>('referrals'),
  defaults: initialState
})
@Injectable()
export class ReferralState {

  constructor(
    private store:Store,
    private userProfileApiService: UserProfileApiService,
  ) {}
  @Action(GetReferralTokenAction)
  handleGetReferalTokenAction(ctx: StateContext<ReferralStateModel>, action: GetReferralTokenAction){
    return this.userProfileApiService.getReferralLink().pipe(
      tap( token => {
        const state = ctx.getState();
        ctx.patchState({token})
      }),
      catchError( err => {
        return throwError(err)
      })
    )
  }

  @Action(GetReferralAction)
  handleGetReferralsAction(ctx: StateContext<ReferralStateModel>, action: GetReferralAction){
   const filter = ctx.getState()?.referralListFilter;
   const actionFilter  = action.payload.filter;

   let reqFilter: ReferralListFilterModel;

   if (filter){

     reqFilter = {
       ...filter,
       ...actionFilter
     }

   } else {
     reqFilter = {
       page: actionFilter.page,
       size: Constants.PAGE_SIZE,
   }
   }
    return this.userProfileApiService.getReferrals(reqFilter).pipe(
      tap( referralPage => {
        const state = ctx.getState();
        ctx.patchState({referralPage}),
          catchError( err => {
            return throwError(err)
          })
      })
    )
  }
  @Selector()
  static getUserReferedToken(state: ReferralStateModel) {
    return state?.token;
  }
  @Selector()
  static getReferralList(state: ReferralStateModel): ReferralModel[] {
    return state?.referralList
  }
  @Selector()
  static getReferral(state: ReferralStateModel) {
    return state?.referral;
  }

  @Selector()
  static getReferralPage(state: ReferralStateModel): PageableApiResult<ReferralModel> {
    return state?.referralPage;
  }

}
